import React from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { useLanguageContext } from "../../Context/LanguageContext";
export default function TicketFilterDropDown({
  state,
  setState,
  handleDropDownChanges,
}) {
  const [stateAnchorEl, setStateAnchorEl] = React.useState(null);
  const { localization } = useLanguageContext();
  const optionList1 = [
    { Name: localization.openTicket, value: "open" },
    { Name: localization.inprogress, value: "inProgress" },
    { Name: localization.close, value: "close" },
  ];

  const handleStateClick = (event) => {
    setStateAnchorEl(event.currentTarget);
  };

  const handleStateClose = (newState) => {
    if (newState) {
      setState(newState);
      handleDropDownChanges(newState);
    }
    setStateAnchorEl(null);
  };
  return (
    <>
      <Button
        variant="contained"
        className="gridTableButton gridTableButtonStyle"
        style={{ marginLeft: 8 }}
        onClick={handleStateClick}
        endIcon={<UnfoldMoreIcon />}
      >
        {localization.Status} {":"}{" "}
        {state == "open"
          ? localization.openTicket
          : state == "inProgress"
            ? localization.inprogress
            : localization.close}
      </Button>
      <Menu
        anchorEl={stateAnchorEl}
        open={Boolean(stateAnchorEl)}
        onClose={() => handleStateClose(null)}
      >
        {optionList1.map((item, index) => (
          <MenuItem
            key={index}
            style={{ fontSize: "16px" }}
            onClick={() => handleStateClose(item.value)}
          >
            {item.Name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
